<template>
  <div class="galleryWrapper">
    <div class="picturesDiv">
      <div class="picture">
        <img class="picture fadeIn animated" v-for="(picture, index) in images" v-if="index < maxImages" ref="image" v-bind:src="picture" v-on:click="bigImageIndex = index; disableScroll()">
        <div class="placeHolder fadeIn animated" v-bind:style="{height: this.$refs.image[0].clientHeight + 'px'}" v-if="placeholderCount >= 1"></div>
        <div class="placeHolder2 fadeIn animated" v-bind:style="{height: this.$refs.image[0].clientHeight + 'px'}" v-if="placeholderCount == 2"></div>
      </div>
      <button class="moreLess filterShadow" v-if="images.length > 9" v-on:click="toggleImages()">{{ moreLessString }}</button>
      <transition name="fade">
        <div v-if="bigImageIndex != undefined" class="lightbox" style="display: block">
          <div class="lightboxImageWrapper" v-on:click.self="bigImageIndex = undefined; enableScroll()">
            <div class="previous" v-on:click="indexDown" v-if="bigImageIndex > 0"/>
            <transition name="fade">
              <img class="lightbox" v-on:click.self="indexUp" v-bind:key="images[bigImageIndex]" v-bind:src="images[bigImageIndex]">
            </transition>
            <div class="next" v-on:click="indexUp" v-if="bigImageIndex < maxImages" />
           </div>
         </div>
      </transition>
    </div>
  </div>
</template>

<script>
import gallery from './gallery';

    export default {
        name: 'gallery',
        props: {
          images: {
            type:Array,
            required: true
          }
        },
        data: function() {
          return gallery
        },
        methods: {
          indexUp: function() {
            if (this.bigImageIndex < this.maxImages){
              this.bigImageIndex++
            }
          },
          indexDown: function() {
            if (this.bigImageIndex > 0){
              this.bigImageIndex--
            }
          },
          toggleImages: function() {
            if (this.maxImages < this.images.length){
              if (this.images.length % 3 !== 0) {
                var moduloCount = this.images.length % 3;
                this.placeholderCount = 3 - moduloCount;
                this.maxImages = this.images.length;
              } else {
                this.maxImages = this.images.length;
              }
              this.moreLessString = "LESS";
            } else if (this.maxImages == this.images.length) {
              this.placeholderCount = 0;
              this.maxImages = 9;
              this.moreLessString = "MORE";
            }
          },
        }
    }
</script>

<style scoped lang="scss">
    @import './_gallery';
</style>



// WEBPACK FOOTER //
// src/components/gallery/gallery.vue